import {DeleteProductPayloadDto} from '@features/product/application/use_cases/delete-product/dto/delete-product.payload.dto';
import {DeleteProductResponseDto} from '@features/product/application/use_cases/delete-product/dto/delete-product.response.dto';
import {DeleteProductHttpPayloadDto} from '@features/product/infrastructure/http/delete-product/delete-product.http.payload.dto';
import {DeleteProductHttpResponseDto} from '@features/product/infrastructure/http/delete-product/delete-product.http.response.dto';

export class DeleteProductHttpMapper {

  static toResponse(data: DeleteProductHttpResponseDto): DeleteProductResponseDto {
    return {};
  }

  static toInfra(data: DeleteProductPayloadDto): DeleteProductHttpPayloadDto {
    return {};
  }

}
